import { styled } from '@mui/material';

export const Wrapper = styled('div')`
  display: flex;
  width: 100%;
  flex-direction: column;
`;

export const Ticket = styled('div')`
  display: flex;
  align-items: center;
  width: 100%;
  position: relative;
  border-top: 0;
  border-right: 0;
  border-bottom: 0;
  padding: 16px;
  border-radius: 6px;
  margin-bottom: 16px;

  font-weight: 600;
  line-height: 19.84px;
`;

export const Title = styled('div')`
  font-weight: 700;
  line-height: 19.84px;
  margin-bottom: 24px;
`;

export const TotalTitle = styled(`div`)`
  font-weight: 700;
  line-height: 19.84px;
`;

export const TotalTextContainer = styled('div')`
  display: flex;
  justify-content: space-between;
  width: 100%;
  border-top: 1px solid #e5e7eb;
  padding-top: 12px;
  margin-top: 12px;
`;

export const EmptyDescription = styled('span')``;
